import { useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

export const useListFilterDataLoading = (fetchData, clear) => {
  const init = useRef();
  const listFilter = useSelector(s => s.listFilter, shallowEqual);

  useEffect(() => {
    if (init.current) return;

    if (listFilter.status === 'succeeded') {
      init.current = true;
      fetchData();
    }
  }, [listFilter.status, init, fetchData]);

  useEffect(() => () => {
    clear();
  }, [clear]);
};
